module.exports = __webpack_public_path__ + "static/media/DE neue.2d2576df.svg";